import {LokaltDatalager} from "../LokaltDatalager";
import {IPromise} from "angular";
import {Språk} from "./Spraak";
import _ from "lodash";

export class Språklager {

    static regNavn = "Språklager";

    static lokallagernøkkel = "chosenLanguage";

    private _tilgjengeligSpråk: Språk[];

    static forInjisering() {
        return [
            LokaltDatalager.regNavn,
            Språklager
        ]
    }

    constructor(private datalager: LokaltDatalager) {
        this._tilgjengeligSpråk = Språk.tilgjengeligSpråk();
    }

    harValgtSpråk(): IPromise<boolean> {
        return this.datalager.eksisterer(Språklager.lokallagernøkkel);
    }

    hentValgtSpråk(): IPromise<Språk> {
        return this.datalager.hent(Språklager.lokallagernøkkel)
            .then(lagretSpråk => this.finnSpråkFraServerTag(lagretSpråk));
    }

    lagreValgtSpråk(språk: Språk) {
        this.datalager.lagre(Språklager.lokallagernøkkel, språk.servertag);
    }

    private finnSpråkFraServerTag(tag: string): Språk {
        return _(this._tilgjengeligSpråk).find((språk) => språk.servertag == tag);
    }
}
